import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";
import CheckoutForm from "../../components/Book/CheckoutForm";
import DownloadApp from "../home/DownloadApp";
import { useLocation } from "react-router";

const Checkout = () => {
  const location = useLocation(); // Get the location object
  const { book } = location.state || {};
  return (
    <body className="courses-grid-page">
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="စာအုပ်ဝယ်ယူမည်" />
          <CheckoutForm book={book}/>
          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default Checkout;
